
import {updateFilterUrl, parseFilterUrl} from './functions/url';
import {filterItems} from './functions/filters';

import React, { useState, useEffect } from 'react';

import FilterUI from './FilterUI';




function App() {
  const items = _filter_data;
  console.log(_filter_data)
  let filter_form = _filter_form;
  let url_data = parseFilterUrl(filter_form);
  filter_form = url_data.form;
  let current_page = url_data.page;

  let top_filters = {};

  filter_form.forEach((form_item) => {
    if (form_item.type == "top"){
      top_filters = form_item;
    }
  });

  let active_filters = {
    mobile_open: false,
    active_panel: 'side_filter',
    top_filter_open: false,
    side_filter_open: false,
    active_side_filter: '',
    active_date_panel: ''
  }


  let start_date = "",
      end_date = "";

  filter_form.forEach((selected_filter) => {
      if (selected_filter.name === "date"){
          selected_filter.elements.forEach((element) => {
              if (element.id === "date_from"){
                  start_date = element.value;
              }
              if (element.id === "date_to"){
                  end_date = element.value;
              }
          });
      }
  })


  return (
    <>
      <FilterUI
        filter_form={filter_form}
        top_filters={top_filters}
        items={items}
        current_page={current_page}
        active_filters={active_filters}
        start_date={start_date}
        end_date={end_date}/>
    </>
  );
}

export default App;
